import type { State } from "@store/reducers";
import type { PaginationExtendedType } from "@types";
import { getPagination } from "@selectors";

export const isLoadingAuditLogs = (state: State): boolean => {
  return state.service.auditLogs.requestsInProgress > 0;
};

export const selectAbsenceAuditLogsList = (state: State) =>
  state.service.auditLogs.absenceAuditLogs.content || [];

export const selectAbsenceAuditLogsPagination = (state: State): PaginationExtendedType =>
  getPagination(state.service.auditLogs.absenceAuditLogs);

export const selectNotificationAuditLogsList = (state: State) =>
  state.service.auditLogs.notificationAuditLogs.content || [];

export const selectNotificationAuditLogsPagination = (state: State): PaginationExtendedType =>
  getPagination(state.service.auditLogs.notificationAuditLogs);
